// GHL is white-labelled — the agency dashboard is FranklyBoost, not
// gohighlevel.com. Kept as an env var so the host can change without a code
// edit; falls back to the known FranklyBoost host (#380).
const GHL_APP_BASE_URL =
  (import.meta.env.VITE_GHL_APP_BASE_URL as string | undefined) ?? "https://app.franklyboost.com";

/**
 * The contact's GHL conversation page, or null when the contact isn't synced
 * (either id missing). The ids are encoded as path segments: they're trusted
 * GHL ids, but encoding means a malformed value can never manipulate the path.
 * Shared by OpenInGhlButton and the quote drawer (#1559).
 */
export function ghlContactHref(
  ghlLocationId: string | null | undefined,
  ghlContactId: string | null | undefined,
): string | null {
  if (!ghlLocationId || !ghlContactId) return null;
  return `${GHL_APP_BASE_URL}/v2/location/${encodeURIComponent(ghlLocationId)}/contacts/detail/${encodeURIComponent(ghlContactId)}`;
}
